import { ReactNode } from "react";

export interface SentinelListProps {
  applicationId?: number;
  actionId?: number;
  actionType?: string;
  intentGroupId?: number;
  emptyText?: ReactNode;
  excludeHeader?: boolean;
  onSentinelClick?: (sentinelId: number) => void;
}

export enum SeverityLevel {
  UNRECOGNIZED = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  FATAL = 4,
}